import { z } from 'zod'

import { autocallBarrierStepSchema } from '@/pages/instruments/new-instrument/schemas/shared/autocall-barrier-step.schema'
import { baseStructuredSchema } from '@/pages/instruments/new-instrument/schemas/shared/base-structured.schema'
import { knockdownInputLevelSchema } from '@/pages/instruments/new-instrument/schemas/shared/knockdown-input-level.schema'

export const ObservationFrequencySchema = z.union([
  z.literal(1),
  z.literal(2),
  z.literal(3),
  z.literal(4),
  z.literal(6),
  z.literal(12),
])

export const autocallStandardSchema = baseStructuredSchema.extend({
  instrument_type: z.literal('autocall-standard'),

  autocall_yearly_observations: ObservationFrequencySchema,
  coupon_yearly_observations: ObservationFrequencySchema,
  coupon_rate_annual: z.number(),
  autocall_barrier_level: z.number(),

  knockdown_input_level: knockdownInputLevelSchema,
  autocall_barrier_step: autocallBarrierStepSchema,
})

export type AutocallStandardSchemaType = z.infer<typeof autocallStandardSchema>
